import CustomAsyncSelect from "../CustomAsyncSelect";

const ProductCategorySelect = ({
    label,
    description,
    placeholder = "Search and select categories...",
    value = [],
    onChange,
    name = "productCategories",
    className,
    containerClass,
    ...props
}) => {
    // Transform API data to select options
    const transformData = (cat) => ({
        value: cat.id,
        label: cat.name,
        count: cat.count,
        parent: cat.parent,
    });

    // Format option label with category ID and product count
    const formatOptionLabel = (option) => (
        <div className="flex items-center justify-between w-full py-[0.20rem]">
            <div className="flex items-center gap-2 flex-1 min-w-0">
                <span className="text-xs font-medium text-gray-500 flex-shrink-0">
                    #{option.value}
                </span>
                <span className="text-sm text-gray-900 truncate">
                    {option.label}
                </span>
            </div>
            {option.count !== undefined && (
                <span className="text-xs text-gray-500 ml-3 flex-shrink-0">
                    {option.count} {option.count === 1 ? "item" : "items"}
                </span>
            )}
        </div>
    );

    return (
        <CustomAsyncSelect
            label={label}
            value={value}
            onChange={onChange}
            name={name}
            placeholder={placeholder}
            description={description}
            className={className}
            containerClass={containerClass}
            endpoint="wc/v3/products/categories"
            transformData={transformData}
            formatOptionLabel={formatOptionLabel}
            searchParams={{
                orderby: "name",
                order: "asc",
                hide_empty: "false",
            }}
            selectedLabel="Category"
            selectedLabelPlural="Categories"
            noOptionsText="Start typing to search categories..."
            {...props}
        />
    );
};

export default ProductCategorySelect;
